import Channel from '../../classes/channel';
import ChannelUtils from '../../utils/channels';
import EpgEvent from '../../classes/epgEvent';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IChannelsState, IUserState } from '../../types/interfaces/states';
import { RootState } from '../store';

const initialState: IChannelsState = {
  channelsData: undefined,
  currentChannel: undefined,
  currentIndex: 0,
  favouriteChannels: undefined,
  filteredChannels: undefined,
  hiddenChannels: undefined,
};

const channelsSlice = createSlice({
  name: 'channels',
  initialState,
  reducers: {
    clearChannels: (state) => {
      state.channelsData = undefined;
      state.currentChannel = undefined;
      state.currentIndex = 0;
      state.favouriteChannels = undefined;
      state.filteredChannels = undefined;
      state.hiddenChannels = undefined;
    },
    channelDown: (state) => {
      ChannelUtils.channelDown(state);
    },
    channelUp: (state) => {
      ChannelUtils.channelUp(state);
    },
    loadChannels: (
      state,
      action: PayloadAction<{
        anonymousId: string;
        channels: Channel[];
        user: IUserState;
      }>
    ) => {
      ChannelUtils.loadChannels(state, action.payload);
    },
    loadHiddenChannels: (state, action: PayloadAction<Channel[]>) => {
      state.hiddenChannels = action.payload;
    },
    loadUnavailableChannels: (state, action: PayloadAction<Channel[]>) => {
      state.unavailableChannels = action.payload;
    },
    prioritizeChannel: (state, action: PayloadAction<string>) => {
      state.currentIndex = 0;
      const channelsSorted = ChannelUtils.sortChannels(
        state.channelsData?.slice() as Channel[]
      );
      const channelPrioritized = channelsSorted.find(
        (item) => item.code === action.payload
      );
      // Prioritize channel on the entire channel set for zapper
      // to display correctly
      state.channelsData = channelPrioritized
        ? [
            channelPrioritized,
            ...channelsSorted.filter((item) => item.code !== action.payload),
          ]
        : channelsSorted;
      // Prioritize channel on favourite channels set
      state.favouriteChannels = state.channelsData.filter((channel) =>
        state.favouriteChannels?.includes(channel)
      );
    },
    setChannel: (state, action: PayloadAction<Channel | number>) => {
      if (typeof action.payload === 'number') {
        ChannelUtils.setChannelByDial(state, action.payload);
      } else {
        ChannelUtils.setChannelByIndex(state, action.payload);
      }
    },
    updateEvent: (state, action: PayloadAction<EpgEvent | undefined>) => {
      if (action.payload && state.currentChannel) {
        state.currentChannel.currentEvent = action.payload;
      }
    },
  },
});

const { actions, reducer: channelsReducer } = channelsSlice;
export const {
  clearChannels,
  channelDown,
  channelUp,
  loadChannels,
  loadHiddenChannels,
  loadUnavailableChannels,
  prioritizeChannel,
  setChannel,
  updateEvent,
} = actions;
export const channelsSelector = (state: RootState) => state.channels;
export default channelsReducer;
